require('./angular-messages');
module.exports = 'ngMessages';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-messages/index.js
 ** module id = 14
 ** module chunks = 0
 **/